import apiClient from "../apiClient";

const resource = "organization";

export default {
    // Anonymous and read-only: the login page reads it before sign-in; it is edited in Management.
    get: () => apiClient.get(resource),
};
